// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"34":"async-mermaid","572":"async-burger","597":"async-lottie"}[chunkId] + ".js";
};